import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ShareDataService } from 'src/app/_services/ShareData.service';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { DataSource } from 'src/app/_models/DataSource';
import { ActionType } from 'src/app/_models/ActionType.enum';

@Component({
  selector: 'app-addnewemail',
  templateUrl: './addnewemail.component.html',
  styleUrls: ['./addnewemail.component.css']
})
export class AddnewemailComponent implements OnInit {

  currentApiKey: any;
  emailForm: FormGroup;
  isSaving= false;
  @ViewChild('closeBtn') closeBtn: ElementRef;

  selectedData: any;


  constructor(private _shareData: ShareDataService, private _adminService: AdminServiceService, private _alertify: AlertifyService) { }

  ngOnInit() {

    this.initFormForNew();

    this._shareData.currentApiKey.subscribe(apiKey => {
      this.currentApiKey = apiKey;
    });

    this._shareData.currentDataSource.subscribe(data => {

      this.selectedData = data;

      if (this.selectedData)
      {
        if (!this.selectedData.value) {
          this.initFormForNew();
        } else {
          this.initFormForUpdate(this.selectedData.value);
        }
      }
  
    });

  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('PasswordEmail').value === g.get('confirmPassword').value ? null : { 'mismatch': true };
  }

  addEmail() {

    this.isSaving = true;
    var emailData = this.emailForm.value;
    emailData.APIKey = this.currentApiKey;

    if (this.selectedData && this.selectedData.id && this.selectedData.id > 0) {
      emailData.Id = this.selectedData.id;
      this._adminService.updateEmailConfiguration(emailData, this.currentApiKey).subscribe(()=> {
        this._alertify.success("Email Configuration Updated Successfully");
        this.notifyAction(this.selectedData.id, ActionType.Updated,  "emailconfiguration", emailData);
        this.closeBtn.nativeElement.click();
        this.isSaving = false;
      }, error => {
        this._alertify.error(error);
        this.isSaving = false;
      });      
    } else {
      this._adminService.addNewEmailConfiguration(emailData).subscribe(response => {
        emailData.id = response["id"];
        this._alertify.success("Email Configuration Added Successfully");
        this.notifyAction(emailData.id, ActionType.Added, "emailconfiguration", emailData);
        this.closeBtn.nativeElement.click();
        this.isSaving = false;
      }, error => {
        this._alertify.error(error);
        this.isSaving = false;
      });
    }
  }

  private initFormForNew() {
    this.emailForm = new FormGroup({
      FromEmail: new FormControl('', Validators.required),
      smtpServer: new FormControl('', Validators.required),
      Port: new FormControl('', Validators.required),
      PasswordEmail: new FormControl(''),
      confirmPassword: new FormControl('')
    }, this.passwordMatchValidator);  
  }

  private initFormForUpdate(data) {

    this.emailForm = new FormGroup({
      FromEmail: new FormControl(data.fromEmail, Validators.required),
      smtpServer: new FormControl(data.smtpServer, Validators.required),
      Port: new FormControl(data.port, Validators.required),
      PasswordEmail: new FormControl(''),
      confirmPassword: new FormControl('')
    }, this.passwordMatchValidator);  

  }

  private notifyAction(id: any, action: ActionType, key: string,  value: any) {
    this._shareData.notifyCurrentDataSource(new DataSource(id, action, key, value ));
  }
  
}
